// extracted by mini-css-extract-plugin
module.exports = {"formButtonGroup":"_3C8Al","centerAlign":"_2tg73","errorCode":"_3uIjx","errImg":"_1CXzy"};